import { api } from 'common';

///////////////////////////////////////////////////
////// TYPES and CONST
export const APPOINTMENT_KIND_TYPE_NAME = 'AppointmentKind';
const APPOINTMENT_KIND_EXTRACT_TYPE_NAME = 'AppointmentKindExtract';

export type OrchestratorInstance =
  api.Orchestrator.ApiInstance.ApiInstance | api.Orchestrator.EhrInstance.EhrInstance;

export const OrchestratorInstanceKind =
  api.Orchestrator.OrchestratorInstance.OrchestratorInstanceKind;
export type OrchestratorInstanceKind =
  api.Orchestrator.OrchestratorInstance.OrchestratorInstanceKind;

export const INSTANCE_KIND_LABELS: Record<OrchestratorInstanceKind, string> = {
  [OrchestratorInstanceKind.API]: 'API',
  [OrchestratorInstanceKind.EHR]: 'EHR',
};

///////////////////////////////////////////////////
////// MAPPINGS

// Rather than conflate the canonical_fields table to hold multiple values,
// we set up a mapping for write/read to the EHR based on this map. If you need a reverse
// mapping, set the user facing canonical field type as the key and the mapped
// canonical field type as the value.
export const ApiInstanceReadValueMap = new Map<string, string>([
  [APPOINTMENT_KIND_TYPE_NAME, APPOINTMENT_KIND_EXTRACT_TYPE_NAME],
]);
